const API = process.env.REACT_APP_API_ENDPOINT;

export const service = {
  loginTools: async (data) => {
    const response = await fetch(`${API}/api/token-login`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.message || "Login fallito.");
    }

    return await response.json();
  },

  logout: async (token) => {
    const response = await fetch(`${API}/api/logout`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.message || "Logout fallito.");
    }

    return await response.json();
  },

  getUser: async (token) => {
    const response = await fetch(`${API}/api/user`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });

    if (!response.ok) {
      const text = await response.text();
      throw new Error(text || "Errore");
    }

    return await response.json();
  },

  getCollaborators: async (token, partner_id) => {
    const response = await fetch(
      `${API}/api/collaborators/partner/${partner_id}`,
      {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );

    if (!response.ok) {
      const text = await response.text();
      throw new Error(text || "Errore");
    }

    return await response.json();
  },

  startAllEvaluo: async (token) => {
    const response = await fetch(`${API}/api/evaluations/start`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });

    if (!response.ok) {
      const text = await response.text();
      throw new Error(text || "Errore");
    }

    return await response.json();
  },

  startSingleEvaluo: async (token, id_collaborator) => {
    const response = await fetch(
      `${API}/api/evaluations/start/${id_collaborator}`,
      {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );

    if (!response.ok) {
      const text = await response.text();
      throw new Error(text || "Errore");
    }

    return await response.json();
  },

  getAllEvaluations: async (token) => {
    const response = await fetch(`${API}/api/evaluations`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });

    if (!response.ok) {
      const text = await response.text();
      throw new Error(text || "Errore");
    }

    return await response.json();
  },

  getSingleEvaluation: async (token, id_evaluation) => {
    const response = await fetch(`${API}/api/evaluation/${id_evaluation}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });

    if (!response.ok) {
      const text = await response.text();
      throw new Error(text || "Errore");
    }

    return await response.json();
  },

  saveEvaluation: async (token, id_evaluation, eValuo) => {
    const response = await fetch(
      `${API}/api/evaluation/${id_evaluation}/save`,
      {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ data: eValuo }),
      }
    );

    if (!response.ok) {
      const text = await response.text();
      throw new Error(text || "Errore");
    }

    return await response.json();
  },

  submitEvaluation: async (token, id_evaluation) => {
    const response = await fetch(
      `${API}/api/evaluation/${id_evaluation}/submit`,
      {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );

    if (!response.ok) {
      const text = await response.text();
      throw new Error(text || "Errore");
    }

    return await response.json();
  },

  deleteEvaluation: async (token, id_evaluation) => {
    const response = await fetch(
      `${API}/api/evaluation/delete/${id_evaluation}`,
      {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );

    if (!response.ok) {
      const text = await response.text();
      throw new Error(text || "Errore");
    }

    return await response.json();
  },

  submitCallReviewEvaluation: async (
    token,
    id_evaluation,
    comment_call_review
  ) => {
    const response = await fetch(
      `${API}/api/evaluation/${id_evaluation}/save-review`,
      {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ comment_call_review }),
      }
    );

    if (!response.ok) {
      const text = await response.text();
      throw new Error(text || "Errore");
    }

    return await response.json();
  },
};
